import React, { useEffect } from 'react';
import { useRouter } from 'next/router';

export function truncateToTwoDecimalPlaces(number) {
  const formattedNumber = Number(number?.toFixed(2));
  return formattedNumber.toFixed(2);
}

const TabbyWidget = ({ price, locale, page }) => {
  const { pathname } = useRouter();
  // const minvalue = process.env.NEXT_PUBLIC_TABBY_MIN_VALUE;
  // const maxvalue = process.env.NEXT_PUBLIC_TABBY_MAX_VALUE;

  return (
    !pathname.startsWith('/success') && (
      <div className='mt-4'>
        <TabbyPromoSnippet
          key={`${price}-${locale}`}
          price={price}
          locale={locale}
          source={page || 'product'}
        />
      </div>
    )
  );
};

export default TabbyWidget;

const TabbyPromoSnippet = ({ locale, price, source }) => {
  useEffect(() => {
    // Load the Tabby Promo script when the component mounts
    const script = document.createElement('script');
    script.src = 'https://checkout.tabby.ai/tabby-promo.js';
    script.async = true;
    document.body.appendChild(script);

    // Initialize TabbyPromo after the script is loaded
    script.onload = () => {
      // eslint-disable-next-line no-undef
      new TabbyPromo({
        selector: '#TabbyPromo',
        currency: 'SAR',
        price: truncateToTwoDecimalPlaces(price),
        lang: locale === 'en' ? 'en' : 'ar',
        source: source || 'product',
        publicKey: process.env.NEXT_PUBLIC_TABBY_TOKEN,
        merchantCode: 'el-omarksa',
      });
    };

    // Clean up script on component unmount
    return () => {
      document.body.removeChild(script);
    };
  }, [locale, price, source]);

  return <div id='TabbyPromo'></div>; // The div where the Tabby Promo Snippet will be shown
};
